
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.675 5.915a4.527 4.527 0 002.036-2.455 9.044 9.044 0 01-2.889 1.035 4.51 4.51 0 00-3.264-1.494c-2.914-.06-5.111 2.613-4.512 5.449a12.812 12.812 0 01-9.202-4.908 4.52 4.52 0 001.27 6.054 4.48 4.48 0 01-2.031-.608c-.093 2.09 1.365 4.078 3.526 4.558a4.517 4.517 0 01-2.04.034 4.519 4.519 0 004.151 3.222A9.08 9.08 0 011 18.532a12.765 12.765 0 006.875 2.171c8.379.175 13.26-6.802 13.106-13.155a9.196 9.196 0 002.3-2.289 9.054 9.054 0 01-2.606.656z","fill":"#1DA1F2"}})])
          )
        }
      }
    